import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ErrorCodePlaceholderIllustration = function ErrorCodePlaceholderIllustration(_a) {
  var className = _a.className,
    _a$color = _a.color,
    color = _a$color === undefined ? 'sapphire' : _a$color,
    _a$statusCodeStyle = _a.statusCodeStyle,
    statusCodeStyle = _a$statusCodeStyle === undefined ? {
      fontSize: '44px',
      fontWeight: 900,
      fontFamily: 'sans-serif'
    } : _a$statusCodeStyle,
    _a$statusCode = _a.statusCode,
    statusCode = _a$statusCode === undefined ? 200 : _a$statusCode,
    otherProps = __rest(_a, ["className", "color", "statusCodeStyle", "statusCode"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ErrorCodePlaceholderIllustration",
    role: "img",
    viewBox: "0 0 112 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "72",
    fill: "none",
    className: classNames('cogs-illustration', 'cogs-themed-icon', className)
  }, otherProps, {
    children: [jsx("text", {
      className: "cogs-error-illustration-text",
      dominantBaseline: "middle",
      textAnchor: "middle",
      x: "50%",
      y: "55%",
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      opacity: 0.5,
      style: statusCodeStyle,
      children: statusCode
    }), jsx("g", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      opacity: ".15",
      children: jsx("path", {
        d: "M1 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v71a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zM9 1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v70a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zM21 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v70a1 1 0 0 1-1 1H22a1 1 0 0 1-1-1zM37 1a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v70a1 1 0 0 1-1 1H38a1 1 0 0 1-1-1zM65 1a1 1 0 0 1 1-1h44a1 1 0 0 1 1 1v70a1 1 0 0 1-1 1H66a1 1 0 0 1-1-1z"
      })
    })]
  }));
};

export { ErrorCodePlaceholderIllustration };
